// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityUpdate_container__FfzyX","form":"ActivityUpdate_form__2pJcQ"};